import { Injectable } from '@angular/core';
import { Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WebService } from '../web.service';
import { AttendanceJustification } from '../../class/attendance-justification';

@Injectable()
export class AttendanceJustificationService extends WebService {
    public getAttendanceJustificationAll (citation_id: number, page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (page !== null && page !== undefined) {
            params.append('_page', String(page));
        } else {
            params.append('_page', '1');
        }

        if (per_page !== null && per_page !== undefined) {
            params.append('_limit', String(per_page));
        } else {
            params.append('_limit', '10');
        }

        if (sort !== null && sort !== undefined) {
            params.append('_sort', String(sort));
        }

        if (filters !== null && filters !== undefined && filters.length > 0) {
            filters.forEach(element => {
                params.append(element.key, String(element.value));
            });
        }
        params.append('citation_id', String(citation_id));
        params.append('_with', String('user.employee'));

        const options = new RequestOptions({search: params, headers: this.headers});
        

        return this.http.get( `${this.apiUrl}/citation-justification?${params}`, options);
    }
    public getAttendanceJustification (id: number, page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (page !== null && page !== undefined) {
            params.append('_page', String(page));
        } else {
            params.append('_page', '1');
        }

        if (per_page !== null && per_page !== undefined) {
            params.append('_limit', String(per_page));
        } else {
            params.append('_limit', '10');
        }

        if (sort !== null && sort !== undefined) {
            params.append('_sort', String(sort));
        }

        if (query !== null && query !== undefined && query !== '') {
            params.append('_q', String(query));
        }

        if (filters !== null && filters !== undefined && filters.length > 0) {
            filters.forEach(element => {
                params.append(element.key, String(element.value));
            });
        }

        params.append('_with', String('user.employee'));

        const options = new RequestOptions({search: params, headers: this.headers});
        

        return this.http.get( `${this.apiUrl}/citation-justification?${id}`, options);
    }

    public getAttendanceJustificationByEvent(id: number, id_attendance: number): Observable<Response> {
        return this.http.get( `${this.apiUrl}/citations/${id_attendance}/citation-justification?id=${id}`,  { headers: this.headers } );    }

    public newAttendanceJustification(id: number, body: Object): Observable<Response> {
        return this.http.post( `${this.apiUrl}/citations/${id}/citation-justification`, JSON.stringify(body) , { headers: this.headers } );
    }

    public updateAttendanceJustification(id: number, body: Object): Observable<Response> {
        return this.http.patch( `${this.apiUrl}/citation-justification/${id}`, JSON.stringify(body) , { headers: this.headers } );
    }

    public deleteAttendanceJustification(id: number): Observable<Response> {
        return this.http.delete( `${this.apiUrl}/citation-justification/${id}`, { headers: this.headers } );
    }

    public infoAttendanceJustification(id: number): Observable<Response> {
        return this.http.get( `${this.apiUrl}/citation-justification?id=${id}`,  { headers: this.headers } );
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/attendance-justification/attendance-justification.service.ts